export interface TestCase {
    id: string;
    name: string;
    description: string;
    steps: TestStep[];
    expectedResult: string;
    actualResult?: string;
    status: TestStatus;
    startTime?: Date;
    endTime?: Date;
    duration?: number;
    error?: string;
}

export interface TestStep {
    id: string;
    action: TestAction;
    element?: string;
    value?: any;
    expectedResult?: string;
    actualResult?: string;
    status: TestStatus;
    screenshot?: string;
}

export interface TestSuite {
    id: string;
    name: string;
    route: string;
    component: string;
    testCases: TestCase[];
    status: TestStatus;
    startTime?: Date;
    endTime?: Date;
    duration?: number;
    successCount: number;
    failureCount: number;
    totalCount: number;
}

export interface TestReport {
    id: string;
    name: string;
    startTime: Date;
    endTime?: Date;
    duration?: number;
    testSuites: TestSuite[];
    totalTests: number;
    passedTests: number;
    failedTests: number;
    successRate: number;
    environment: string;
}

export enum TestStatus {
    PENDING = 'pending',
    RUNNING = 'running',
    PASSED = 'passed',
    FAILED = 'failed',
    SKIPPED = 'skipped'
}

export enum TestAction {
    NAVIGATE = 'navigate',
    CLICK = 'click',
    INPUT = 'input',
    SELECT = 'select',
    UPLOAD_FILE = 'upload_file',
    WAIT = 'wait',
    ASSERT_TEXT = 'assert_text',
    ASSERT_ELEMENT_EXISTS = 'assert_element_exists',
    ASSERT_ELEMENT_VISIBLE = 'assert_element_visible',
    ASSERT_VALUE = 'assert_value',
    TAKE_SCREENSHOT = 'take_screenshot'
}

export interface TestConfiguration {
    baseUrl: string;
    timeout: number;
    retryCount: number;
    screenshotOnFailure: boolean;
    parallelExecution: boolean;
    routes: RouteTestConfig[];
}

export interface RouteTestConfig {
    path: string;
    name: string;
    component: string;
    testCases: string[];
    dependencies?: string[];
} 